// extracted by mini-css-extract-plugin
module.exports = {"nav":"AppLayout_nav__3W7x0","logo":"AppLayout_logo__MNpGT","component":"AppLayout_component__3mG18","content":"AppLayout_content__2vg8i","ad":"AppLayout_ad__131ku"};